import { render, staticRenderFns } from "./viewChatWindow.vue?vue&type=template&id=06cb10fb&scoped=true&"
import script from "./viewChatWindow.vue?vue&type=script&lang=js&"
export * from "./viewChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./viewChatWindow.vue?vue&type=style&index=0&id=06cb10fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb10fb",
  null
  
)

export default component.exports